/**
 * Stats class to track global statistics across the application
 * Used for tracking counts of products, insert sets, cards, and other global metrics
 * 
 * Note: The backend MongoDB collection for this model is 'globalStats'
 */
class Stats {
  constructor(data = {}) {
    // We use a fixed ID for the global stats document
    this.id = data._id || data.id || 'global';
    
    // Core statistics
    this.totalProducts = typeof data.totalProducts === 'number' ? data.totalProducts : 0;
    this.totalInsertSets = typeof data.totalInsertSets === 'number' ? data.totalInsertSets : 0;
    this.totalCards = typeof data.totalCards === 'number' ? data.totalCards : 0;
    
    // When the stats were last updated
    this.lastUpdated = data.lastUpdated ? new Date(data.lastUpdated) : new Date();
    
    // Keep the original _id for MongoDB compatibility
    this._id = data._id || this.id;
  }

  /**
   * Convert this object back to API format for sending to server
   */
  toApiFormat() {
    return {
      _id: this.id,
      totalProducts: this.totalProducts,
      totalInsertSets: this.totalInsertSets,
      totalCards: this.totalCards,
      lastUpdated: this.lastUpdated
    };
  }

  /**
   * Create a Stats object from API response data
   * @param {Object} data - API response data
   * @returns {Stats} - Stats instance
   */
  static fromApiResponse(data) {
    const statsData = data.stats || data;
    return new Stats(statsData);
  }
}

// Use CommonJS exports for Node.js backend compatibility
module.exports = Stats;
// Also support ES modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports.default = Stats;
}